export default {"src":"/login-app/[GIT_HASH]/_next/static/media/cached.3e924634.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};